import React, {useRef, useState} from 'react';
import 'react-image-crop/dist/ReactCrop.css'
import {InputText} from "primereact/inputtext";


const FileUploaderForPDF = (props) => {
    const {name, type, label, onUpload, accept} = props;
    const [src, setSrc] = useState(props.src);
    const [file, setFile] = useState(props.file);

    const refUploadInput = useRef(null);

    const handleUploadFile = async (event) => {
        let file = event.target.files[0];
        setFile(file);
        onUpload(file);
    };

    const getPreviewFile = () => {
        if (file) {
            return <iframe src={URL.createObjectURL(file)} width="450" height="600" title={file.name}
                           frameBorder="0" allowFullScreen/>;
        } else if (props.src) {
            return <iframe src={props.src} width="450" height="600" title={props.src} frameBorder="0"
                           allowFullScreen/>;
        }
    }
    return (
        <div className="flex flex-row gap-2 ">
            <div className="grid">
                <div className="col">
                    {file || src ? getPreviewFile() :
                        <i className="pi pi-file-pdf" style={{fontSize: '5rem'}}></i>}
                </div>
                <div className="col">
                    <p>{label}</p>
                    <label id={`${name}-label`} htmlFor={name} className="p-component">
                        <div className="p-inputgroup flex-1" htmlFor={name}>
                            <InputText placeholder="Seçili dosya yok" disabled value={file ? file.name : ""}/>
                            <div className="p-button p-component p-fileupload-choose"><i
                                className="pi pi-plus"/> {file ? "Değiştir" : "Dosya Yükle"}</div>
                        </div>
                    </label>
                    <input name={name} id={name} type="file" style={{visibility: "hidden"}} ref={refUploadInput}
                           accept={accept} onChange={handleUploadFile}/>
                </div>
            </div>
        </div>
    )
}
export default FileUploaderForPDF;
